import { ColumnDef } from '@tanstack/react-table';

import { TickerLogo } from '@/components/TickerLogo';

export const HOLDINGS_COLUMN_LABELS: Record<string, string> = {
    description: 'Description',
    closePrice: 'Price',
    marketValue: 'Value',
    pnlUnrealized: 'Unrealized G/L',
    returnUnrealized: 'Unrealized Return',
};

export const HOLDINGS_POSITION_COLUMNS = [
    'symbol',
    'description',
    'quantity',
    'closePrice',
    'marketValue',
    'pnlUnrealized',
    'returnUnrealized',
];
export const HOLDINGS_OPEN_LOT_COLUMNS = [...HOLDINGS_POSITION_COLUMNS, 'costBasis', 'openDate', 'term'];
export const holdingsColumnVisibility = <T,>(columns: ColumnDef<T, any>[], visible: string[]) =>
    Object.fromEntries(columns.map((column) => [column.id!, visible.includes(column.id!)]));

export const holdingsColumns = <T,>(columns: ColumnDef<T, any>[]): ColumnDef<T, any>[] =>
    columns.map((column) => ({
        ...column,
        header: HOLDINGS_COLUMN_LABELS[column.id!] ?? column.header,
        size: column.id === 'description' ? 340 : column.id === 'symbol' ? 160 : 150,
        ...(column.id === 'symbol'
            ? {
                  cell: ({ getValue }) => (
                      <div className="flex items-center gap-3 font-semibold text-stone-900">
                          <span className="flex size-7 shrink-0 items-center justify-center rounded-md border border-stone-200 bg-white p-1">
                              <TickerLogo tickerSymbol={getValue()} className="max-h-full max-w-full" />
                          </span>
                          {getValue()}
                      </div>
                  ),
              }
            : {}),
    }));
